<template>
  <section class="my-type-graph-wrap">
    <div class="wrap">
      <div class="my-type-graph-left">
        <div v-if="dataGraph && dataGraph.length" class="my-type-bar-wrap">
          <div class="my-type-bar-tit">
            <h4 class="my-type-tit">많이 본 장르</h4>
            <ul class="my-type-bar-btn">
              <li>
                <button :class="tabType === 'broadcast' ? 'my-type-bar-btn-on' : ''" @click.prevent="setTab('broadcast')">VOD</button>
              </li>
              <li>
                <button :class="tabType === 'movie' ? 'my-type-bar-btn-on' : ''" @click.prevent="setTab('movie')">영화</button>
              </li>
            </ul>
            <p class="my-type-bar-desc"><strong>{{pieTitle}}</strong> 장르를 많이 시청하셨네요.</p>
          </div>
          <div class="bar-wrap" v-for="(data, index) in dataGraph" :key="index" :index="index">
            <p class="my-type-genre-tit">
              <span class="my-type-rank">{{index+1}}</span>
              <a v-if="index !== 3">
                <span :class="tabType === 'movie' ? 'movie-genre-link' : ''">{{data.title}}</span>
              </a>
              <template v-else>
                <a>
                  <span>{{data.title}}</span>
                </a>
              </template>
              <span class="my-type-percent">{{Math.floor(data.viewrate * 100)}}%</span>
            </p>
            <stacked-bar-chart :data="stackData[index]" :type="tabType"/>
            <div class="item-wrap">
              <div v-for="(item, itemIndex) in stackData[index]" class="item-txt-wrap" :key="'stack_data_' + itemIndex">
                <a v-if="itemIndex !== 3">
                  <span class="item-cc" :style="'background-color:' + item.color + ';'"><!-- 원 --></span>
                  <span class="item-txt" :class="itemIndex === 3 ? 'item-txt-etc' : ''">{{ item.title }}</span>
                </a>
                <template v-else>
                  <span class="item-cc" :style="'background-color:' + item.color + ';'"><!-- 원 --></span>
                  <span class="item-txt item-txt-etc">{{ item.title }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
        <template v-else-if="dataGraph && !dataGraph.length">
          <div class="my-type-bar-tit">
            <h4 class="my-type-tit">많이 본 장르</h4>
            <ul class="my-type-bar-btn">
              <li>
                <button :class="tabType === 'broadcast' ? 'my-type-bar-btn-on' : ''" @click.prevent="setTab('broadcast')">VOD</button>
              </li>
              <li>
                <button :class="tabType === 'movie' ? 'my-type-bar-btn-on' : ''" @click.prevent="setTab('movie')">영화</button>
              </li>
            </ul>
          </div>
          <div v-if="viewType === 'vod'" class="my-type-empty">
            <empty-list text="<p>이용한 VOD 콘텐츠가 없어요.<br/>지금 바로 시청해보시는 건 어때요?</p>"></empty-list>
            <a href="#" @click.prevent="moveUrl('home')">홈으로 이동하기</a>
          </div>

          <div v-if="viewType === 'movie'" class="my-type-empty">
            <empty-list text="<p>이용한 영화 콘텐츠가 없어요.<br/>지금 바로 시청해보시는 건 어때요?</p>"></empty-list>
            <a href="#" @click.prevent="moveUrl('home')">홈으로 이동하기</a>
          </div>
        </template>
        <div v-if="dataGraph && dataGraph.length" class="my-type-pie-wrap">
          <div class="mypooq-chart-circle">
            <div id="donutchart">
              <vue-chart chart-type="PieChart" :columns="columns" :rows="pieData" :options="options"/>
            </div>
            <div class="runnung-time"><p>{{viewTime}}</p>시간</div>
          </div>
        </div>
      </div>
      <div class="my-type-total-wrap" v-if="dataDevice">
        <h4 class="my-type-tit">주 사용 디바이스</h4>
        <ul class="my-type-total-list">
          <li v-for="(data, index) in dataDevice" :key="index">
            <div class="my-type-ico"><img :src="typeImage(data.devicename)" alt=""/></div>
            <div class="my-type-total-desc">
              <p class="my-type-total-tit">{{data.devicename}}</p>
              <p class="my-type-total-text"><strong>{{data.viewtime}}</strong> 시간 이용</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import StackedBarChart from '@/components/mypooq/StackedBarChart'
import { getAnalysisGraph } from '@/common/utils/request'
import { setNumberCommas } from '@/common/utils/common'
import EmptyList from '@/components/mypooq/EmptyList'
export default {
  components: {
    StackedBarChart,
    EmptyList
  },
  props: {
    dataDevice: {
      type: Array
    }
  },
  data () {
    return {
      dataGraph: [],
      tabType: 'broadcast',
      viewType: 'broadcast',
      viewTime: '',
      pieTitle: '',
      pieData: [],
      stackData: [[], [], [], []],
      fontColor: [
        ['#1351f9', '#5986ff', '#90aeff', '#bfd0ff'],
        ['#00bbec', '#5cceec', '#94e8ff', '#e3f9ff'],
        ['#5532d3', '#7e65da', '#ac9fdd', '#e2dbfb']],
      options: {
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.0,
        enableInteractivity: false,
        pieSliceBorderColor: 'none',
        backgroundColor: '#1b1b1b',
        slices: {
          0: { color: '#1351f9' },
          1: { color: '#00bbec' },
          2: { color: '#5532d3' },
          3: { color: '#a5a5a5' }
        },
        width: 620,
        height: 620,
        pieSliceTextStyle: { color: '#fff', fontSize: 22, fontName: 'NotoSans' },
        legend: { position: 'bottom', textStyle: { color: '#a5a5a5', fontSize: 14 } }
      },
      columns: [
        {
          type: 'string',
          label: 'title'
        },
        {
          type: 'number',
          label: 'percent'
        }
      ]
    }
  },
  methods: {
    setTab (type) {
      this.tabType = type
      if (type === 'broadcast') type = 'vod'
      getAnalysisGraph({ type }).then(({ data }) => {
        this.viewTime = _.get(data, 'viewtime', '') > 9999 ? '9,999+' : setNumberCommas(_.get(data, 'viewtime', ''))
        this.dataGraph = _.get(data, 'analysisgraphlist', [])
        this.pieData = []
        this.stackData = [[], [], [], []]
        this.pieTitle = ''
        if (this.dataGraph.length > 0) {
          let pieData = this.dataGraph.map((item, index) => {
            if (index < 4) {
              this.pieData.push([item.title, item.viewrate * 100])
              return item
            }
          })

          let title = pieData.map((item, index) => {
            if (index < 3) return item.title
          })
          this.pieTitle = _.join(title, ',')

          for (let i = 0; i < 3; i++) {
            const subListLen = _.get(this.dataGraph, `${i}.sublist`, []).length
            for (let j = 0; j < subListLen; j++) {
              this.stackData[i].push(
                {
                  title: this.dataGraph[i].sublist[j].title,
                  value: this.dataGraph[i].sublist[j].viewrate * 100,
                  genre: this.dataGraph[i].sublist[j].parentsid,
                  linkvalue: this.dataGraph[i].sublist[j].linkvalue,
                  color: this.fontColor[i][j]
                }
              )
            }
          }
        }
        this.viewType = type
      })
    },
    typeImage (type) {
      let filenamePath = require.context('../../assets/images/mypooq/', false, /\.png$/)
      let filename = ''

      switch (type) {
        case 'Android':
          filename = 'icon-mobile-61'
          break
        case 'PC':
          filename = 'icon-pc-61'
          break
        case 'TV':
          filename = 'icon-mobile-tv'
          break
        default:
          filename = 'icon-mobile-61'
      }
      return filenamePath('./' + filename + '.png')
    },
    moveUrl (type) {
      this.$router.push({ name: type })
    }
  },
  created () {
    this.setTab('broadcast')
  }
}
</script>

<style>
.movie-genre-link{
  border-bottom: 1px solid #ccc;
}
</style>
